window.Analytics = {};